export default __webpack_public_path__ + "static/media/Spinner-1s-200px.d3fcc2d2.gif";